import { Component, OnInit, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common'

import { ChartService } from '../../../services/chart.service';

@Component({
  selector: 'enrich-graph',
  templateUrl: './enrich-graph.component.html'
})
export class EnrichGraphComponent implements OnInit {

  enrichData: any;
  enrichGraphOptions: any;

  totalPhone: number = 0;
  totalTitle: number = 0;
  hasData: boolean = false;

  @Input()
  set data(data: any) {
    this.enrichData = data;
    this.updateView();
  }

  constructor(private chartService: ChartService, private decimalPipe: DecimalPipe) {
    this.enrichGraphOptions = this.chartService.defaultChart;
    this.enrichGraphOptions.chart.type = 'column';
    this.enrichGraphOptions.chart.height = '320';
    this.enrichGraphOptions.legend.verticalAlign = 'top';
    this.enrichGraphOptions.legend.align = 'center';

    this.enrichGraphOptions.xAxis = {
      type: 'date',
      labels: {
        format: '{value:%b %d}'
      }
    };

    this.enrichGraphOptions.yAxis = {
      title: {
        text: null
      },
      gridLineWidth: 1,
      tickWidth: 1,
      labels: {
        style: {
          fontSize: '14px'
        }
      }
    };

    this.enrichGraphOptions.tooltip = {
      headerFormat: '{point.key:%b %d, %Y}<br/>',
      shared: true
    };

    this.enrichGraphOptions.plotOptions.column = {
      pointPadding: 0,
      borderWidth: 0
    };
  }

  ngOnInit() {
  }

  updateView() {
    this.hasData = false;
    let phone: any[] = [];
    let title: any[] = [];
    this.enrichGraphOptions.xAxis.categories = [];
    if (this.enrichData && this.enrichData.contacts.length > 0) {
      this.enrichData.aggregate.forEach((agg) => {
        this.enrichGraphOptions.xAxis.categories.push(new Date(agg.date));
        phone.push(agg.phone);
        title.push(agg.title);
        this.totalPhone += agg.phone;
        this.totalTitle += agg.title;
      });

      this.enrichGraphOptions.series = [
        {
          name: `Phone Numbers Added (${this.decimalPipe.transform(this.totalPhone)})`,
          data: phone,
          color: this.chartService.enrichColors[0]
        },
        {
          name: `Job Titles Added (${this.decimalPipe.transform(this.totalTitle)})`,
          data: title,
          color: this.chartService.enrichColors[1]
        }
      ];

      this.hasData = true;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/global/analytics/enrich-graph/enrich-graph.component.ts